export var VisualizerType;
(function (VisualizerType) {
    VisualizerType["CUBE"] = "cube";
    VisualizerType["CUBE_NET"] = "cube-net";
    VisualizerType["CUBE_TOP"] = "cube-top";
    VisualizerType["MEGAMINX"] = "megaminx";
    VisualizerType["MEGAMINX_NET"] = "megaminx-net";
    VisualizerType["MEGAMINX_TOP"] = "megaminx-top";
    VisualizerType["PYRAMINX"] = "pyraminx";
    VisualizerType["PYRAMINX_NET"] = "pyraminx-net";
    VisualizerType["SKEWB"] = "skewb";
    VisualizerType["SKEWB_NET"] = "skewb-net";
    VisualizerType["SQUARE1"] = "square1";
    VisualizerType["SQUARE1_NET"] = "square1-net";
})(VisualizerType || (VisualizerType = {}));
